import utils from '../utils/utils';
import * as firebase from 'firebase';

const shouldDisconnectVisitor = (lastActiveTimestamp, timeTillDisconnect) => {
  const diffMs = new Date() - lastActiveTimestamp;
  const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
  return (timeTillDisconnect && (diffMins >= timeTillDisconnect));
};

class FirebaseChatService {

  messagePath;
  presencePath;
  visitorInstanceId;
  initialConnection = true;
  db;
  channel;
  pn = {};
  firesbaseInitialLoading = true;
  presenceState = {
    timestamp: '',
    lastSeenTimestamp: '',
    pageName: '',
    location: '',
    typing: false,
    deviceType: ''
  };
  lastActiveTimestamp;
  lastDisconnectionTime;

  init({authKey, options, messagePath, presencePath, visitorInstanceId, timeTillDisconnect}) {
    this.messagePath = messagePath;
    this.presencePath = presencePath;
    this.visitorInstanceId = visitorInstanceId;
    this.timeTillDisconnect = timeTillDisconnect;
    this.lastActiveTimestamp = new Date();

    if (!this.initialConnection) {
      window.clearInterval(this.interval);
      this.interval = null;
      this.fb = null;
    }

    this.fb = firebase.initializeApp(options, utils.createGuid());
    return this.fb
      .auth().signInWithCustomToken(authKey)
      .then(() => this.db = this.fb.database())
      .then(this.setHeartbeat.bind(this))
      .then(() => this.initialConnection = false)
      .then(() => this);
  }

  setLastSeenTimestamp() {
    this.updatePresence({lastSeenTimestamp: firebase.database.ServerValue.TIMESTAMP});
  }

  goOnlineIfOffline() {
    this.lastActiveTimestamp = new Date();
    if (!this.interval) {
      this.fb.database().goOnline();
      this.setHeartbeat();
    }
  }

  setHeartbeat() {
    const self = this;
    this.interval = setInterval(() => {
      if (shouldDisconnectVisitor(self.lastActiveTimestamp, self.timeTillDisconnect)) {
        window.clearInterval(self.interval);
        self.interval = null;
        self.fb.database().goOffline();
      }
      self.updatePresence({lastSeenTimestamp: firebase.database.ServerValue.TIMESTAMP});
    }, 1000 * 30);
  }

  updateChannelAndAuth({channel, authKey}) {
    this.channel = channel;
    this.pn.setAuthKey(authKey);
  }

  removeOnDisconnect() {
    this.db.ref(this.presencePath).onDisconnect().remove();
  }

  subscribe({messageCallback, timestamp, onConnectionInfoChange}) {
    const messagesRef = this.db.ref(this.messagePath).orderByChild('timestamp').startAt(new Date(timestamp).getTime());
    const connectionInfoRef = this.db.ref('.info/connected');

    // Make sure we remove all previous listeners.
    messagesRef.off();

    connectionInfoRef.on('value', connectedSnap => {
      onConnectionInfoChange({
        connectionIsOn: connectedSnap.val(),
        lastDisconnectionTime: this.lastDisconnectionTime,
        isInitial: this.firesbaseInitialLoading
      });
      if (connectedSnap.val() === true) {
        this.updatePresence(); // this will set state with all previous data
        this.removeOnDisconnect();
        this.firesbaseInitialLoading = false;
      } else {
        this.lastDisconnectionTime = Date.now();
      }
    });

    messagesRef.on('child_added', snapshot => {
      const val = snapshot.val();
      messageCallback(typeof val === 'string' ? JSON.parse(val) : val);
    });
    return this;
  }

  updatePresence(newState) {
    Object.assign(this.presenceState, newState);
    this.db.ref(this.presencePath).set(this.presenceState);
    return this;
  }
}

export default new FirebaseChatService();




// WEBPACK FOOTER //
// ./chat-app/services/firebaseChatService.js